/*
 * CleanHack native PDP helper (sections/ch-pack-offer.liquid).
 * Works only through Dawn's own components: it checks a radio in Dawn's <variant-selects> and
 * dispatches the same 'change' event a buyer click would, so Dawn's product-info.js does the
 * variant update. It never calls /cart/*. Dawn's product-form.js stays the single cart writer.
 */
(function () {
  'use strict';
  var dataEl = document.getElementById('ch-pdp-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var dbg = (window.__chPdp = { preselect: 'pending', badge: null, atc: null });
  var packIdx = (D.packPosition || 0) - 1;

  function fmt(n, dec, th, dp) {
    var s = n.toFixed(dec).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return s.join(dp);
  }
  function money(cents) {
    var f = D.moneyFormat || '${{amount}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var n = (Number(cents) || 0) / 100;
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(n, 0, '.', ','); break;
      default: v = fmt(n, 2, ',', '.');
    }
    return m ? f.replace(m[0], v) : '$' + v;
  }
  function variantById(id) {
    id = Number(id);
    for (var i = 0; i < D.variants.length; i++) if (D.variants[i].id === id) return D.variants[i];
    return null;
  }
  function info() { return document.querySelector('product-info[id^="MainProduct-"]'); }
  function mainForm() {
    var el = info();
    return el ? document.getElementById('product-form-' + el.dataset.section) : null;
  }
  function packFieldset() {
    var el = info();
    if (!el || packIdx < 0) return null;
    var sets = el.querySelectorAll('variant-selects fieldset');
    return sets[packIdx] || null;
  }
  function selectedValues() {
    var el = info();
    var out = [];
    if (!el) return out;
    el.querySelectorAll('variant-selects fieldset, variant-selects select').forEach(function (node) {
      if (node.tagName === 'SELECT') { out.push(node.value); return; }
      var c = node.querySelector('input[type="radio"]:checked');
      out.push(c ? c.value : null);
    });
    return out;
  }
  function preferredForCurrent() {
    var sel = selectedValues();
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      if (v.options[packIdx] !== D.preferredValue) continue;
      var ok = true;
      for (var j = 0; j < v.options.length; j++) if (j !== packIdx && sel[j] != null && v.options[j] !== sel[j]) ok = false;
      if (ok) return v;
    }
    return null;
  }

  function applyBadge() {
    var fs = packFieldset();
    if (!fs) return;
    var target = preferredForCurrent();
    var input = null;
    fs.querySelectorAll('input[type="radio"]').forEach(function (i) { if (i.value === D.preferredValue) input = i; });
    fs.querySelectorAll('.ch-pack-badge').forEach(function (b) { b.remove(); });
    if (!input) return;
    var label = fs.querySelector('label[for="' + input.id + '"]');
    if (!label) return;
    var text = D.badgeText || 'MOST POPULAR';
    if (target && target.save > 0) text = text.replace('[amount]', money(target.save).replace(/[.,]00(?=\D*$)/, ''));
    else text = text.split(/\s*[—–-]\s*SAVE/i)[0];
    var badge = document.createElement('span');
    badge.className = 'ch-pack-badge';
    badge.setAttribute('data-ch-pack-badge', '');
    badge.textContent = text;
    label.classList.add('ch-pack-promoted');
    label.appendChild(badge);
    dbg.badge = text;
  }

  function relabelAtc() {
    if (!D.priceInAtc) return;
    var form = mainForm();
    if (!form) return;
    var btn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    var span = btn && btn.querySelector('span');
    var idField = form.querySelector('input[name="id"]');
    if (!span || !idField || btn.hasAttribute('disabled')) return;
    var v = variantById(idField.value);
    if (!v || !v.available) return;
    span.textContent = D.atcLabel + ' · ' + money(v.price);
    dbg.atc = span.textContent;
  }

  function refresh() { applyBadge(); relabelAtc(); }

  function preselect() {
    if (!D.preselect || packIdx < 0) { dbg.preselect = 'off'; return; }
    if (/[?&]variant=/.test(window.location.search)) { dbg.preselect = 'skipped: ?variant in URL'; return; }
    var fs = packFieldset();
    if (!fs) { dbg.preselect = 'no picker'; return; }
    var input = null;
    fs.querySelectorAll('input[type="radio"]').forEach(function (i) { if (i.value === D.preferredValue) input = i; });
    var target = preferredForCurrent();
    if (!input || input.checked) { dbg.preselect = input ? 'already selected' : 'no preferred value'; return; }
    if (!target || !target.available) { dbg.preselect = 'preferred variant unavailable'; return; }
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    dbg.preselect = 'dispatched ' + target.id;
  }

  // "Buy It Now" buttons in lower sections link to this product: scroll to the buy box instead of reloading.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.button[href]');
    if (!a || a.closest('product-info, header, footer, .ch-sticky')) return;
    var url;
    try { url = new URL(a.href, window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin || url.pathname !== D.productUrl) return;
    var target = document.getElementById('ch-buy') || (info() && info().querySelector('variant-selects'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { refresh(); });
    }
    // Fallback for any path that changes the id without a variantChange publish.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') setTimeout(refresh, 0);
    });
    refresh();
    preselect();
  }

  if (window.customElements && customElements.whenDefined) {
    Promise.all([customElements.whenDefined('product-info'), customElements.whenDefined('variant-selects')])
      .then(init)
      .catch(init);
  } else {
    init();
  }
})();
